import { render, staticRenderFns } from "./PermissionCheckBox.vue?vue&type=template&id=4d1f040f"
import script from "./PermissionCheckBox.vue?vue&type=script&lang=js"
export * from "./PermissionCheckBox.vue?vue&type=script&lang=js"
import style0 from "./PermissionCheckBox.vue?vue&type=style&index=0&id=4d1f040f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports